import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-683e3260")

_pushScopeId("data-v-683e3260")
const _hoisted_1 = {
  ref: "containerRadio",
  class: "w-full block flex form-radio-container"
}
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionsRadio, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: ["items-center flex justify-center flex-1 form-radio", [
        item.value === _ctx.modelValue ? 'active' : '',
        _ctx.disabled ? 'disabled' : '',
      ]],
        onClick: ($event: any) => (_ctx.actionSubmit(item))
      }, [
        (item.textTooltip)
          ? (_openBlock(), _createBlock(_component_Tooltip, {
              key: 0,
              textTooltip: item.textTooltip,
              locationTooltip: "top",
              class: "justify-center w-full h-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_RadioInput, {
                  label: item.label,
                  value: item.value,
                  modelValue: _ctx.selected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event)),
                  disabled: _ctx.disabled
                }, null, 8, ["label", "value", "modelValue", "disabled"])
              ]),
              _: 2
            }, 1032, ["textTooltip"]))
          : (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_RadioInput, {
                disabled: _ctx.disabled,
                label: item.label,
                value: item.value,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected = $event))
              }, null, 8, ["disabled", "label", "value", "modelValue"])
            ]))
      ], 10, ["onClick"]))
    }), 128))
  ], 512))
})